function PickIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="icon-park-outline:shopping-bag">
                <g id="Vector">
                    <path d="M3.33594 11.333H28.6693L25.8693 28.6663H6.13594L3.33594 11.333ZM23.3359 11.333H17H8.66927"
                        fill="white"/>
                    <path d="M23.3359 11.333H17H8.66927M3.33594 11.333H28.6693L25.8693 28.6663H6.13594L3.33594 11.333Z"
                        stroke="#6E6864" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <g id="Group">
                    <path id="Vector_2"
                        d="M23.3359 11.333C23.3359 6.91501 20.0526 3.33301 16.0026 3.33301C11.9526 3.33301 8.66927 6.91501 8.66927 11.333M3.33594 11.333H28.6693L25.8693 28.6663H6.13594L3.33594 11.333Z"
                        stroke="#6E6864" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path id="Vector_3"
                        d="M11.3372 18.6662C12.0736 18.6662 12.6706 18.0692 12.6706 17.3328C12.6706 16.5965 12.0736 15.9995 11.3372 15.9995C10.6009 15.9995 10.0039 16.5965 10.0039 17.3328C10.0039 18.0692 10.6009 18.6662 11.3372 18.6662Z"
                        fill="#6E6864"/>
                    <path id="Vector_4"
                        d="M12.0039 21.9995C12.0039 21.9995 13.3372 23.9995 16.0039 23.9995C18.6706 23.9995 20.0039 21.9995 20.0039 21.9995"
                        stroke="#6E6864" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                    <path id="Vector_5"
                        d="M20.6693 18.6663C21.4057 18.6663 22.0026 18.0694 22.0026 17.333C22.0026 16.5966 21.4057 15.9997 20.6693 15.9997C19.9329 15.9997 19.3359 16.5966 19.3359 17.333C19.3359 18.0694 19.9329 18.6663 20.6693 18.6663Z"
                        fill="#6E6864"/>
                </g>
            </g>
        </svg>
    );
}

export default PickIcon;
